import * as stylex from '@stylexjs/stylex';
import Link from 'next/link';
import { TinaMarkdown, TinaMarkdownContent } from 'tinacms/dist/rich-text';
import { typography } from '../styles/typography';
import '../styles/tokens.stylex';
import { fontWeights, layoutTokens, spacing } from '../styles/tokens.stylex';
import Image from 'next/image';
interface AnchorProps {
  url?: string | null;
  children?: React.ReactNode | null;
}
type ComponentConfig = React.ComponentProps<typeof TinaMarkdown>['components'];
export interface RichTextProps {
  children: TinaMarkdownContent | TinaMarkdownContent[];
  components?: ComponentConfig;
  wrapperStyles?: stylex.StyleXStyles;
}
function Anchor(props: AnchorProps | undefined) {
  if (props?.url) {
    return <Link href={props.url}>{props.children}</Link>;
  }
  return <span {...props} />;
}
export const defaultRichTextComponents: ComponentConfig = {
  h1: props => <h1 {...stylex.props(typography.heading1, sx.heading, sx.contentWidth)} {...props} />,
  h2: props => <h2 {...stylex.props(typography.heading2, sx.heading, sx.contentWidth)} {...props} />,
  h3: props => <h3 {...stylex.props(typography.heading3, sx.heading, sx.contentWidth)} {...props} />,
  h4: props => <h4 {...stylex.props(typography.heading4, sx.heading, sx.contentWidth)} {...props} />,
  h5: props => <h5 {...stylex.props(typography.heading4, sx.heading, sx.contentWidth)} {...props} />,
  h6: props => <h6 {...stylex.props(typography.heading4, sx.heading, sx.contentWidth)} {...props} />,
  p: props => <p {...stylex.props(typography.body, sx.p, sx.contentWidth)} {...props} />,
  ul: props => <ul className="xjh29tw xahocic xitt8df" {...props} />,
  li: props => <li {...stylex.props(typography.body, sx.li)} {...props} />,
  strong: props => <strong className="x19n2uve" {...props} />,
  em: props => <em className="x1k4tb9n" {...props} />,
  i: props => <i className="x1k4tb9n" {...props} />,
  a: props => <Anchor {...props} />,
  img: props => props?.url ? <span className="x1s1u9ye xj3kzzz x1n2onr6 x1lliihq x7giv3 xman319">
        <Image className="xl1xv1r" alt={props?.alt || ''} src={props.url} fill sizes="100%, (min-width: 920px): 920px" />
      </span> : <div />,
  blockquote: props => <blockquote className="xitt8df xman319 x1k4tb9n xgvtefl" {...props} />
};
export function RichText({
  children,
  components,
  wrapperStyles,
  ...props
}: RichTextProps) {
  return <div {...stylex.props(sx.wrapper, wrapperStyles)} {...props}>
      <TinaMarkdown content={children} components={{
      ...defaultRichTextComponents,
      ...components
    }} />
    </div>;
}
const sx = {
  wrapper: {
    k1K539: "xuh6244",
    $$css: true
  },
  heading: {
    keoZOQ: "xhj8ucd",
    k1K539: "xhbfen4",
    $$css: true
  },
  p: {
    k1K539: "x13xjzxd xzboxd6",
    $$css: true
  },
  li: {
    k8WAf4: "x1tqsu7c",
    $$css: true
  },
  contentWidth: {
    kBCFzs: "xitt8df",
    $$css: true
  }
};